<fui-message-label *ngIf="label" [title]="label"></fui-message-label>
<div class="spinner-control">
    <fui-mark-button class="spinner-control-button"
                     [disabled]="loading || readonly || !currentValue"
                     (click)="updateValue(-increment)">
        <fui-icon icon="remove" height="14" width="14"></fui-icon>
    </fui-mark-button>
    <div *ngIf="!loading" class="spinner-control-field">
        <div *ngIf="!loading" class="spinner-control-field-value">
            {{currentValue || (placeholder ? (placeholder | translate) : '')}}
            <div *ngIf="notation && (currentValue || placeholder)" class="spinner-control-field-value-notation">
                {{notation | translate}}
            </div>
        </div>
        <fui-icon *ngIf="!loading && !readonly && currentValue"
                  class="spinner-control-field-clear" icon="close" height="10" width="10"
                  [clickable]="true" (click)="clearValue()"></fui-icon>
    </div>
    <div *ngIf="loading" class="spinner-control-loading">
        <fui-spinning-loader class="spinner-control-loading-spinner"></fui-spinning-loader>
    </div>
    <fui-mark-button class="spinner-control-button"
                     [disabled]="loading || readonly"
                     (click)="updateValue(increment)">
        <fui-icon icon="plus" height="14" width="14"></fui-icon>
    </fui-mark-button>
</div>
